import { AsyncPipe } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { SavingPlansPageBase } from '@zero/saving-plans/feature-saving-plans/base';
import { SepaFacade } from '@zero/self-service/domain';
import { UserNotesComponent } from '@zero/shared/ui-web-components';
import { SavingPlanExistingPlansComponent } from './components/saving-plan-existing-plans/saving-plan-existing-plans.component';
import { SavingPlanMostChosenListComponent } from './components/saving-plan-most-chosen-list/saving-plan-most-chosen-list.component';
import { SavingPlanSubjectsComponent } from './components/saving-plan-subjects/saving-plan-subjects.component';
import { SavingPlanSuggestionsComponent } from './components/saving-plan-suggestions/saving-plan-suggestions.component';

@Component({
  selector: 'saving-plans-saving-plans-page',
  templateUrl: './saving-plans-page.component.html',
  imports: [
    UserNotesComponent,
    SavingPlanExistingPlansComponent,
    SavingPlanSuggestionsComponent,
    SavingPlanMostChosenListComponent,
    SavingPlanSubjectsComponent,
    AsyncPipe,
  ],
})
export class SavingPlansPageComponent extends SavingPlansPageBase implements OnInit {
  readonly #sepaFacade = inject(SepaFacade);

  public ngOnInit(): void {
    this.loadSavingsPlans(true);
    this.savingPlansFacade.loadMostChosenSavingplans(true);
    this.#sepaFacade.loadHasSepa();
  }
}
